module.exports = __webpack_public_path__ + "static/img/25Q1_BB_MotorShow.f1c7971.jpg";